import React, { Fragment, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

import form from 'modules/ticketPublicPage/stores/vouchers/form';
import view from 'modules/ticketPublicPage/stores/vouchers/view';

import Initial from './Initial';
import WithdrawalInitial from './WithdrawalInitial';
import WithdrawalSummary from './WithdrawalSummary';
import WithdrawalFinal from './WithdrawalFinal';
import WithdrawalSuccess from './WithdrawalSuccess';
import ContactDetails from './ContactDetails';
import PaymentDetails from './PaymentDetails';
import Confirmation from './Confirmation';
import Action from './common/Action';
import {
  Container,
  FormContainer,
  NotAvailableMessage,
} from './styles/_buyVoucher';
import Header from './Header';

const BuyVoucher = observer(({ isWithdrawal }) => {
  const stepContainerRef = useRef(null);
  const {
    step,
    INITIAL,
    CONTACT_DETAILS,
    PAYMENT_DETAILS,
    CONFIRMATION,
    WITHDRAWAL_INITIAL_STEP,
    WITHDRAWAL_SUMMARY_STEP,
    WITHDRAWAL_FINAL_STEP,
    WITHDRAWAL_SUCCESS_STEP,
  } = form;
  const { activeObject } = view;

  useEffect(() => {
    if (stepContainerRef.current && step !== INITIAL) {
      stepContainerRef.current.focus();
    }
  }, [step, INITIAL]);

  useEffect(() => {
    if (isWithdrawal) {
      form.step = WITHDRAWAL_INITIAL_STEP;
      form.isWithdrawal = true;
    }
  }, [isWithdrawal, WITHDRAWAL_INITIAL_STEP]);

  const renderForm = () => {
    switch (step) {
      case INITIAL:
        return <Initial />;
      case CONTACT_DETAILS:
        return <ContactDetails />;
      case PAYMENT_DETAILS:
        return <PaymentDetails />;
      case CONFIRMATION:
        return <Confirmation />;
      case WITHDRAWAL_INITIAL_STEP:
        return <WithdrawalInitial />;
      case WITHDRAWAL_SUMMARY_STEP:
        return <WithdrawalSummary />;
      case WITHDRAWAL_FINAL_STEP:
        return <WithdrawalFinal />;
      case WITHDRAWAL_SUCCESS_STEP:
        return <WithdrawalSuccess />;
    }
  };

  const ariaContainerLabel =
    step === INITIAL
      ? i18n.gettext('Voucher Purchase')
      : step === CONTACT_DETAILS
        ? i18n.gettext('Contact Details')
        : step === PAYMENT_DETAILS
          ? i18n.gettext('Payment Details')
          : step === CONFIRMATION
            ? i18n.gettext('Voucher purchase confirmation')
            : step === WITHDRAWAL_INITIAL_STEP
              ? i18n.gettext('Voucher withdrawal')
              : step === WITHDRAWAL_SUMMARY_STEP
                ? i18n.gettext('Voucher withdrawal summary')
                : step === WITHDRAWAL_FINAL_STEP
                  ? i18n.gettext('Voucher withdrawal confirmation')
                  : step === WITHDRAWAL_SUCCESS_STEP
                    ? i18n.gettext('Voucher withdrawal success')
                    : '';

  return (
    <Container
      role="region"
      tabIndex={0}
      aria-label={ariaContainerLabel}
      aria-live="assertive"
      ref={stepContainerRef}
    >
      {step !== CONFIRMATION && !isWithdrawal && <Header />}
      <FormContainer>
        {activeObject.status === 'active' || form.isWithdrawal ? (
          <Fragment>{renderForm()}</Fragment>
        ) : (
          <NotAvailableMessage>
            <div>
              {i18n.gettext(
                'We are sorry, but currently we do not sell vouchers.'
              )}
            </div>
            <div>
              {i18n.gettext(
                "Please don't hesitate to contact us if you have any questions!"
              )}
            </div>
          </NotAvailableMessage>
        )}
      </FormContainer>
      <Action />
    </Container>
  );
});

export default BuyVoucher;
